import type { PushDevice } from 'src/entities/push'
import type { IPushDeviceGateway } from 'src/use-cases/push/ports/IPushDeviceGateway'
import { apiNotifire } from 'api/config'

// Приложение в notifire = отправитель канала push (аккаунт push-адаптера).
const APP = 'seller'
// Кто регистрирует устройство (журнал реестра notifire).
const SOURCE = 'seller-app'

// «Вилка»: реестр устройств notifire, POST /v2/device (upsert по токену).
export class PushDeviceHttpGateway implements IPushDeviceGateway {
  async register(device: PushDevice) {
    if (!apiNotifire) return

    await apiNotifire.post('/v2/device', {
      app: APP,
      source: SOURCE,
      platform: device.platform,
      token: device.token,
      user_id: device.userId,
      phone: device.phone,
      os_version: navigator.userAgent.match(/(Android|iPhone OS|CPU OS) [\d._]+/)?.[0] ?? '',
      locale: 'ru',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
  }

  async unregister(token: string) {
    if (!apiNotifire) return

    await apiNotifire.post('/v2/device/unregister', { token, source: SOURCE })
  }
}
